{
  "name": "jeopardy",
  "version": "1.0.2",
  "description": "jeopardy - Release on 24/09/2019 15:31",
  "author": "",
  "license": "",
  "private": true,
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port 4200 --open",
    "e2e": "ng e2e",
    "test": "ng test",
    "lint": "ng lint",
    "lint:autofix": "ng lint --fix",
    "clean": "rimraf dist",
    "build": "ng build",
    "build-dev": "ng build --configuration=dev",
    "build-prod": "ng build",
    "build:stats": "npm run clean && npm run lint:autofix && ng build --configuration=prod --stats-json && webpack-bundle-analyzer dist/stats.json",
    "build:major": "npm --no-git-tag-version version major && npm run build:prod",
    "build:minor": "npm --no-git-tag-version version minor && npm run build:prod",
    "build:patch": "npm --no-git-tag-version version patch && npm run build:prod",
    "generate-graphql-api": "graphql-codegen",
    "generate-graphql-api:watch": "graphql-codegen -w",
    "generate-rest-api": "npx @openapitools/openapi-generator-cli generate -i swagger.json -g typescript-angular -o src/app/shared/rest-api",
    "fetch-rest-api-schema": "curl -O https://vicebo.dev.consilium.europa.eu/umbraco/swagger/default/swagger.json"
  },
  "dependencies": {
    "@angular-devkit/architect": "^0.1901.2",
    "@angular/animations": "^19.1.1",
    "@angular/cdk": "^19.1.0",
    "@angular/common": "^19.1.1",
    "@angular/compiler": "^19.1.1",
    "@angular/core": "^19.1.1",
    "@angular/forms": "^19.1.1",
    "@angular/platform-browser": "^19.1.1",
    "@angular/platform-browser-dynamic": "^19.1.1",
    "@angular/router": "^19.1.1",
    "@apollo/client": "^3.12.6",
    "@fortawesome/angular-fontawesome": "^0.10.1",
    "@fortawesome/fontawesome-pro": "^5.15.2",
    "@fortawesome/fontawesome-svg-core": "^1.2.36",
    "@fortawesome/free-brands-svg-icons": "^5.15.4",
    "@fortawesome/free-solid-svg-icons": "^5.15.4",
    "angular-animations": "^0.11.0",
    "apollo-angular": "^8.0.0",
    "core-js": "3.40.0",
    "graphql": "^16.10.0",
    "graphql-ws": "^5.16.0",
    "ngx-sharebuttons": "^10.0.0",
    "react": "^18.0.0",
    "rxjs": "^6.6.3",
    "tslib": "^2.0.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.1.2",
    "@angular-eslint/builder": "^19.0.2",
    "@angular-eslint/eslint-plugin": "^19.0.2",
    "@angular-eslint/eslint-plugin-template": "^19.0.2",
    "@angular-eslint/schematics": "19.0.2",
    "@angular-eslint/template-parser": "^19.0.2",
    "@angular/cli": "^19.1.2",
    "@angular/compiler-cli": "^19.1.1",
    "@angular/language-service": "^19.1.2",
    "@graphql-codegen/cli": "5.0.2",
    "@graphql-codegen/near-operation-file-preset": "3.0.0",
    "@graphql-codegen/typescript": "4.0.9",
    "@graphql-codegen/typescript-apollo-angular": "4.0.0",
    "@graphql-codegen/typescript-operations": "4.2.3",
    "@openapitools/openapi-generator-cli": "^2.15.3",
    "@types/jasmine": "~5.1.4",
    "@types/jasminewd2": "~2.0.13",
    "@types/node": "^22.10.7",
    "@types/react": "^19.0.7",
    "@typescript-eslint/eslint-plugin": "^8.14.0",
    "@typescript-eslint/parser": "^8.14.0",
    "eslint": "^9.14.0",
    "eslint-plugin-import": "2.31.0",
    "eslint-plugin-prefer-arrow": "1.2.3",
    "https-proxy-agent": "^7.0.6",
    "jasmine-core": "~5.4.0",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.3.11",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "^1.5.0",
    "protractor": "~7.0.0",
    "ts-node": "~10.9.2",
    "typescript": "^5.4.5",
    "webpack-bundle-analyzer": "^4.4.0"
  }
}
